import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getAnalytics } from 'firebase/analytics';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyCBx5tOiv91obhbWGxc0ewsQ_PFdrETRoQ',
  authDomain: 'mago-iesgo-dev-d4af6.firebaseapp.com',
  projectId: 'mago-iesgo-dev-d4af6',
  storageBucket: 'mago-iesgo-dev-d4af6.firebasestorage.app',
  messagingSenderId: '703524768653',
  appId: '1:703524768653:web:7dc00406adcd75d0218bc4',
  measurementId: 'G-SSV9TBZLDQ'
};

const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
export const functions = getFunctions(firebaseApp, 'southamerica-east1');
export const storage = getStorage(firebaseApp);
export const analytics = getAnalytics(firebaseApp);

export default firebaseApp;